import React from "react";

const nishant_agte = () => {
  return (
    <div>
      <h1>Nishant Agte</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The eligibility criteria were : CS branch, and 8+ CGPA
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The online aptitude test took place on 6th August. A shortlist for the
        interviews was announced on 8th August after the company’s pre-placement
        talk (PPT), followed by the interviews on the same day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude test consisted of 3 coding questions (1 “correct the code”,
        1 easy, and 1 hard), 3 SQL queries (moderately hard) and around 15 MCQs
        on topics like DSA, OOP, and DBMS.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        19
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced after the company’s PPT on 8th August, and
        the interviews began right after that. So there was hardly any time
        before the interviews. I revised some DBMS topics and web fundamentals.
        I enjoyed singing one of my favourite compositions in classical music
        which helped me stay calm during that window of time.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 interview rounds - technical and HR.
      </p>

      <p>
        The interviews started at around 12 PM, and my first interview started
        at 2:45 PM. It lasted for about 45 mins.
        <br />
        To my surprise, my technical interview started with questions about my
        extracurricular activities. I was then asked to explain my resume. This
        was followed by technical questions (both coding and theoretical) on DSA
        and OOP. After that, I was asked to explain my projects in great detail.
        Next, the interviewer asked which subjects interest me the most, and
        why. Finally, the interview ended with some technical questions on DBMS
        and web fundamentals.
      </p>

      <p>
        I was called for the HR interview roughly 30 to 40 mins later. This
        interview was shorter and lasted for 20 mins.
        <br />
        It began with my academic performances and overall achievements,
        followed by my hobbies, interests and extracurricular activities in
        college. Through questions asked from various angles, the focus then
        shifted on my strengths and weaknesses. I was asked about my technical
        interests and the field I wanted to work in, since I had interned last
        summer in quantum technologies, which was not the domain of this
        company.
      </p>

      <p>
        The final result was announced at 5:30 PM. Out of the 8 candidates
        shortlisted for the HR round, 6 were selected.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        I was asked some theoretical questions on basics of both DSA and OOP.
        Similarly, coding questions on both of these were asked, and both were
        very easy. I was also asked questions on the DBMS concept of
        normalization. The interviewer also asked a few questions on Web
        architecture and basics of networks, for some of which I wasn’t able to
        give an up to the mark answer.
        <br />
        Apart from these questions, the interviewer also focused on critical
        understanding of DSA concepts used in my project. Along with that, I was
        asked a few questions about Git and GitHub too.
        <br />
        The interviewers mostly focus on what you mention in your resume.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ol>
        <li>
          Reading good textbooks, like ‘The C Programming Language’, by KnR,
          Hamacher-Zaky and William Stallings for CO, etc.{" "}
        </li>
        <li>
          LeetCode for DSA (Striver’s sheet + practising other questions){" "}
        </li>
        <li>CodeHelp - by Babbar playlists on YouTube for DBMS</li>
      </ol>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        First and foremost, get your concepts cleared. Try to practice a variety
        of problems, whilst focusing on the important types. While solving, look
        for the patterns, not the particular problems. And lastly, consistent
        practice is the key to crack coding questions in the stipulated time, so
        practise as much as you can.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        As mentioned above, my first interview started with a couple of
        questions on my extracurricular activities and hobbies. Many technical
        questions that required in-depth answers were asked on my projects in
        the same interview.
        <br />
        The HR interview had more questions on extracurricular activities and
        clubs that I am a part of, where I mentioned activities undertaken and
        challenges faced in the Classical Music Club.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Core concepts have utmost importance. Know your resume in and out, and
        see to it that you are able to answer every question asked on what you
        have mentioned in your resume satisfactorily enough, if not perfectly,
        as the interviewers primarily focus on that.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Make sure you get a good conceptual hold on the courses like DSA, OOP,
        DBMS, OS, etc. right when you learn them in your curriculum; this is the
        first step of your preparation.
        <br />
        Stay calm and relaxed during the interviews, the space is yours.
        <br />
        And most importantly, just be yourself! :)
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9403580974
        <br />
        <strong>Email :</strong> <a href="mailto:nishant.agte@gmail.com">nishant.agte@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default nishant_agte;
